module.exports = __webpack_public_path__ + "img/blog-18.d7242bd4.webp";